export const getCompoundTransactionAmount = (amount: string, asset?: string) => {
  const amountInteger = new Intl.NumberFormat('en-GB', { maximumFractionDigits: 8 }).format(Number(amount))
  return `${amountInteger} ${asset}`
}
